module.exports = "/assets/5a7a3a385191c97aa292b77c5a39acf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A3.png
// module id = 1181
// module chunks = 0